var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoTripComCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 12.5,
    r: 12.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1554_198059",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 25
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 12.5,
    r: 12.5,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1554_198059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4998 16.9506C18.4998 17.914 17.727 18.6922 16.7635 18.6975C15.8001 18.7028 15.0219 17.9246 15.0166 16.9612C15.0166 15.9977 15.7895 15.2196 16.7529 15.2143C17.7111 15.2143 18.4892 15.9872 18.4945 16.9453C18.4945 16.9453 18.4945 16.9453 18.4945 16.9506",
    fill: "#F2B73F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 6V8.42979H10.2638V18.7418H13.1647V8.42979H16.9285V6H6.5Z",
    fill: "#2B45F6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTripComCircle);
export default __webpack_public_path__ + "static/media/IcoTripComCircle.7ccdf15ba12c4b8a4621a3eb0f14d328.svg";
export { ForwardRef as ReactComponent };